"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

var lodash_1 = __importDefault(require("lodash"));

var Auth = __importStar(require("./auth"));

var FirebaseStorage = __importStar(require("./storage"));

var firebase_1 = require("../../configs/firebase");

var file_info_type_1 = __importDefault(require("../../constants/file-info-type"));

var ConstantFirebase = __importStar(require("../../configs/firebase"));

var my_error_1 = __importDefault(require("../../models/my-error"));

function _buildRemoteGroup(snapshot) {
  return Object.assign({}, {
    id: snapshot.id
  }, snapshot.data());
}

function search(_x, _x2) {
  return _search.apply(this, arguments);
}

function _search() {
  _search = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(searchText, lastQueryInfo) {
    var list, lastItemMarker, query, querySnapshot, docs, _query, _querySnapshot, _docs, group;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            list = [];
            lastItemMarker = null;

            if (!(searchText === '')) {
              _context.next = 12;
              break;
            }

            query = app_1.default.firestore().collection(firebase_1.CN_GROUP).where('is_public', '==', true).orderBy('edit_at', 'desc').limit(ConstantFirebase.SEARCH_GROUPS_DEFAULT_LIST_LIMIT);

            if (!!lastQueryInfo) {
              query = query.startAfter(lastQueryInfo);
            }

            _context.next = 7;
            return query.get();

          case 7:
            querySnapshot = _context.sent;
            docs = querySnapshot.docs;

            if (docs.length > 0) {
              querySnapshot.forEach(function (doc) {
                list.push(_buildRemoteGroup(doc));
              });
              lastItemMarker = list[list.length - 1].edit_at;
            }

            _context.next = 24;
            break;

          case 12:
            _query = app_1.default.firestore().collection(firebase_1.CN_GROUP).where('search', 'array-contains', lodash_1.default.toLower(searchText)).where('is_public', '==', true).orderBy('edit_at', 'desc');

            if (!!lastQueryInfo) {
              _query = _query.startAfter(lastQueryInfo);
            }

            _context.next = 16;
            return _query.get();

          case 16:
            _querySnapshot = _context.sent;
            _docs = _querySnapshot.docs;

            if (_docs.length > 0) {
              _querySnapshot.forEach(function (doc) {
                list.push(_buildRemoteGroup(doc));
              });

              lastItemMarker = list[list.length - 1].edit_at;
            }

            if (!(!lastQueryInfo && searchText.length === 20)) {
              _context.next = 24;
              break;
            }

            _context.next = 22;
            return getById(searchText);

          case 22:
            group = _context.sent;

            if (group) {
              list.unshift(group);
            }

          case 24:
            return _context.abrupt("return", {
              list: list,
              last_item_marker: lastItemMarker
            });

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _search.apply(this, arguments);
}

exports.search = search;

function getRef(groupId) {
  return app_1.default.firestore().collection(firebase_1.CN_GROUP).doc(groupId);
}

exports.getRef = getRef;

function fetchMyGroups() {
  return _fetchMyGroups.apply(this, arguments);
}

function _fetchMyGroups() {
  _fetchMyGroups = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var userId, querySnapshot, list;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context2.sent;
            _context2.next = 5;
            return app_1.default.firestore().collection(firebase_1.CN_GROUP).where('author_id', '==', userId).orderBy('edit_at', 'desc').get();

          case 5:
            querySnapshot = _context2.sent;
            list = [];
            querySnapshot.forEach(function (doc) {
              list.push(_buildRemoteGroup(doc));
            });
            return _context2.abrupt("return", list);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchMyGroups.apply(this, arguments);
}

exports.fetchMyGroups = fetchMyGroups;

function fetchPopular() {
  return _fetchPopular.apply(this, arguments);
}

function _fetchPopular() {
  _fetchPopular = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var querySnapshot, list;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_GROUP).where('popular', '==', true).where('is_public', '==', true).orderBy('edit_at', 'desc').get();

          case 2:
            querySnapshot = _context3.sent;
            list = [];
            querySnapshot.forEach(function (doc) {
              list.push(_buildRemoteGroup(doc));
            });
            return _context3.abrupt("return", list);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchPopular.apply(this, arguments);
}

exports.fetchPopular = fetchPopular;

function getById(_x3) {
  return _getById.apply(this, arguments);
}

function _getById() {
  _getById = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(groupId) {
    var snapshot;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_GROUP).doc(groupId).get();

          case 2:
            snapshot = _context4.sent;

            if (!snapshot.exists) {
              _context4.next = 7;
              break;
            }

            return _context4.abrupt("return", Object.assign(_buildRemoteGroup(snapshot)));

          case 7:
            return _context4.abrupt("return", null);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getById.apply(this, arguments);
}

exports.getById = getById;

function getListByIds(_x4) {
  return _getListByIds.apply(this, arguments);
}

function _getListByIds() {
  _getListByIds = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(ids) {
    var pms, fetchResult, result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            pms = ids.map(function (id) {
              return getById(id);
            });
            _context5.next = 3;
            return Promise.all(pms);

          case 3:
            fetchResult = _context5.sent;
            result = [];
            lodash_1.default.forEach(fetchResult, function (u) {
              if (u !== null) {
                result.push(u);
              }
            });
            return _context5.abrupt("return", result);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getListByIds.apply(this, arguments);
}

exports.getListByIds = getListByIds;

function remove(_x5) {
  return _remove.apply(this, arguments);
}

function _remove() {
  _remove = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(groupId) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_GROUP).doc(groupId).delete();

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _remove.apply(this, arguments);
}

exports.remove = remove;

function edit(_x6, _x7) {
  return _edit.apply(this, arguments);
}

function _edit() {
  _edit = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(groupId, props) {
    var title, img, tags, is_public, is_receive_noti_contrib, is_auto_approve, cached_owner_nickname, desc, quick_filter_options, sort_options, adv_filter_options, fileRef, nextGroup;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            title = props.title, img = props.img, tags = props.tags, is_public = props.is_public, is_receive_noti_contrib = props.is_receive_noti_contrib, is_auto_approve = props.is_auto_approve, cached_owner_nickname = props.cached_owner_nickname, desc = props.desc, quick_filter_options = props.quick_filter_options, sort_options = props.sort_options, adv_filter_options = props.adv_filter_options;
            fileRef = null;

            if (!img) {
              _context7.next = 10;
              break;
            }

            if (!(img.type === file_info_type_1.default.LOCAL)) {
              _context7.next = 9;
              break;
            }

            _context7.next = 6;
            return FirebaseStorage.uploadIconByFileInfoBlob(img);

          case 6:
            fileRef = _context7.sent;
            _context7.next = 10;
            break;

          case 9:
            if (img.type === file_info_type_1.default.GC) {
              fileRef = img;
            }

          case 10:
            _context7.next = 12;
            return app_1.default.firestore().collection(firebase_1.CN_GROUP).doc(groupId).update({
              title: title,
              img: fileRef,
              tags: tags,
              is_public: is_public,
              is_receive_noti_contrib: is_receive_noti_contrib,
              is_auto_approve: is_auto_approve,
              cached_owner_nickname: cached_owner_nickname || '',
              edit_at: app_1.default.firestore.FieldValue.serverTimestamp(),
              search: _buildSearch(props),
              desc: desc || '',
              quick_filter_options: lodash_1.default.isArray(quick_filter_options) ? quick_filter_options : [],
              sort_options: lodash_1.default.isArray(sort_options) ? sort_options : [],
              adv_filter_options: lodash_1.default.isArray(adv_filter_options) ? adv_filter_options : []
            });

          case 12:
            _context7.next = 14;
            return getById(groupId);

          case 14:
            nextGroup = _context7.sent;

            if (!nextGroup) {
              _context7.next = 19;
              break;
            }

            return _context7.abrupt("return", nextGroup);

          case 19:
            throw new my_error_1.default('Data not found');

          case 20:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _edit.apply(this, arguments);
}

exports.edit = edit;

function add(_x8) {
  return _add.apply(this, arguments);
}

function _add() {
  _add = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(props) {
    var userId, title, img, tags, is_public, is_receive_noti_contrib, is_auto_approve, cached_owner_nickname, desc, fileRef, servNow, uploadContent, docRef, snapshot;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context8.sent;
            title = props.title, img = props.img, tags = props.tags, is_public = props.is_public, is_receive_noti_contrib = props.is_receive_noti_contrib, is_auto_approve = props.is_auto_approve, cached_owner_nickname = props.cached_owner_nickname, desc = props.desc;
            fileRef = null;

            if (!(!!img && img.type === file_info_type_1.default.LOCAL)) {
              _context8.next = 9;
              break;
            }

            _context8.next = 8;
            return FirebaseStorage.uploadIconByFileInfoBlob(img);

          case 8:
            fileRef = _context8.sent;

          case 9:
            servNow = app_1.default.firestore.FieldValue.serverTimestamp();
            uploadContent = {
              author_id: userId,
              owner_id: userId,
              img: fileRef,
              title: title,
              tags: tags,
              search: _buildSearch(props),
              create_at: servNow,
              edit_at: servNow,
              is_public: is_public,
              is_receive_noti_contrib: is_receive_noti_contrib,
              is_auto_approve: is_auto_approve,
              cached_owner_nickname: cached_owner_nickname,
              desc: desc
            };
            _context8.next = 13;
            return app_1.default.firestore().collection(firebase_1.CN_GROUP).add(uploadContent);

          case 13:
            docRef = _context8.sent;
            _context8.next = 16;
            return docRef.get();

          case 16:
            snapshot = _context8.sent;
            return _context8.abrupt("return", _buildRemoteGroup(snapshot));

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _add.apply(this, arguments);
}

exports.add = add;

function _buildSearch(props) {
  var title = props.title,
      tags = props.tags;
  var result = [title];
  lodash_1.default.forEach(tags, function (tag) {
    result.push(lodash_1.default.toLower(tag));
  });
  return lodash_1.default.union(result);
}

function update(_x9, _x10) {
  return _update.apply(this, arguments);
}

function _update() {
  _update = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee9(groupId, props) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_GROUP).doc(groupId).update(props);

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _update.apply(this, arguments);
}

exports.update = update;

function resetNewPendingItemsCounter(_x11) {
  return _resetNewPendingItemsCounter.apply(this, arguments);
}

function _resetNewPendingItemsCounter() {
  _resetNewPendingItemsCounter = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee10(groupId) {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return update(groupId, {
              count_new_pending_items: 0
            });

          case 2:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _resetNewPendingItemsCounter.apply(this, arguments);
}

exports.resetNewPendingItemsCounter = resetNewPendingItemsCounter;